<template>
  <div :class="grid ? 'col-md-' + grid : 'col-md-12'">
    <label v-if="titulo" class="mb-2"
      ><b>{{ titulo }}</b></label
    >
    <div role="group" class="form-group mb-2 d-flex align-items-center">
      <toggle-button
        :disabled="disabled"
        :sync="true"
        color="#5685D8"
        v-model="item"
        v-on:change="$emit('input', item === true ? 1 : 0)"
      />

      <span class="pl-2" v-html="label"></span>
      <b-link
        v-if="ajuda"
        href="#"
        @click.prevent="void 0"
        class="mb-2 ml-2 mt-2"
        variant="info"
        v-b-popover.hover.top="ajuda"
      >
        <i class="fas fa-info-circle"></i>
      </b-link>
    </div>
  </div>
</template>
<script>
export default {
  props: ["titulo", "value", "label", "ajuda", "disabled", "required", "grid", "mt"],
  data() {
    return { item: false };
  },
  watch: {
    value(n, o) {
      this.item = this.value == 1 ? true : false;
    },
  },
  mounted() {
    this.item = this.value == 1 ? true : false;
  },
};
</script>
